import React, { useState } from "react";

const DEMO_QUESTIONS = [
  {
    q: "¿Quién es la autoridad encargada de expedir las licencias de Corredor de Bienes Raíces en Panamá?",
    o: [
      "El Ministerio de Vivienda y Ordenamiento Territorial (MIVIOT).",
      "La Superintendencia de Sujetos No Financieros (SSNF).",
      "La Junta Técnica de Bienes Raíces del Ministerio de Comercio e Industrias.",
      "La Asociación Panameña de Corredores y Promotores de Bienes Raíces (ACOBIR).",
    ],
    c: 2,
    exp: "Según el Decreto Ley 6 de 1999, la Junta Técnica del MICI es la autoridad competente.",
  },
  {
    q: "Un vendedor enajena una propiedad en B/.350,000.00. Su ganancia real demostrable es de B/.30,000.00. Si opta por calcular el impuesto sobre la ganancia real al 10%, ¿cuánto pagará?",
    o: ["B/.3,000.00", "B/.10,500.00", "B/.30,000.00", "B/.35,000.00"],
    c: 0,
    exp: "10% × 30,000 = B/.3,000.00. Trampa: B/.10,500 es el 3% sobre el precio de venta (adelanto); B/.30,000 es la ganancia total sin aplicar la tasa; B/.35,000 es el 10% del precio de venta total.",
  },
  {
    q: "¿A qué resolución anterior modifica específicamente la Resolución No. 395 de 2008?",
    o: [
      "Resolución No. 001 6 de  marzo de 2001",
      "Decreto Ley 6 del 8 de julio de 1999",
      "Resolución No. 012 de 7 de septiembre de 2005",
      "Decreto Ejecutivo No. 39  del 11 de noviembre de 2001",
    ],
    c: 2,
    exp: "Modifica el Artículo Segundo de la Resolución No. 012 de 2005.",
  },
  {
    q: "¿Ante quién deben comprobarse los reclamos por cánones adeudados para afectar el depósito de garantía?",
    o: [
      "Ante la Comisión de Vivienda de la Asamblea Nacional",
      "Ante la Dirección General de Arrendamientos del MIVIOT",
      "Ante el Ministerio Público como acción penal",
      "Directamente ante el Juzgado Civil de primera instancia",
    ],
    c: 1,
    exp: "Toda reclamación sobre el depósito de garantía —por mora o daños— debe tramitarse primero ante la Dirección General de Arrendamientos del MIVIOT. Es la instancia administrativa obligatoria antes de cualquier vía judicial.",
  },
  {
    q: "¿Qué sucede con los contratos de arrendamiento vigentes cuando el inmueble es declarado condenado para demolición?",
    o: [
      "Los contratos siguen plenamente vigentes; los inquilinos no pueden irse",
      "Los contratos quedan resueltos por fuerza mayor: la imposibilidad física extingue la obligación",
      "El dueño debe pagar al inquilino el equivalente a un hotel de por vida",
      "Los inquilinos están obligados a pagar doble canon mientras buscan alojamiento",
    ],
    c: 1,
    exp: "La declaración de condena crea una imposibilidad física sobrevenida: no puede habitarse el inmueble por razones de seguridad. Esta causa de fuerza mayor extingue los contratos de arrendamiento sin culpa de ninguna de las partes.",
  },
  {
    q: "Un productor pregunta qué actividades califican para recibir el descuento de tasa bajo la Ley 4 de 1994. ¿Cuál es el listado correcto?",
    o: [
      "Exclusivamente el cultivo de arroz y maíz como alimentos básicos de la dieta panameña",
      "Agricultura, ganadería, avicultura, acuicultura, silvicultura y forestería",
      "Turismo rural y agroturismo como actividades complementarias del campo panameño",
      "Minería artesanal y extracción de recursos naturales no renovables del subsuelo",
    ],
    c: 1,
    exp: "La Ley 4 de 1994 contempla un amplio espectro de actividades agropecuarias calificadas: agricultura, ganadería, avicultura, acuicultura, pesca, silvicultura y forestería, entre otras. Esta amplitud responde al objetivo de cubrir casi todas las actividades de explotación de recursos naturales renovables, promoviendo la diversificación productiva del campo panameño.",
  },
  {
    q: "Un banco calcula el tramo preferencial para determinar el crédito fiscal que le corresponde. ¿Sobre qué base exacta se calcula el descuento de la tasa de interés bajo el Decreto Ejecutivo 554 de 2019?",
    o: [
      "Sobre el salario mensual del deudor que sirve de base para calcular su capacidad de pago",
      "Sobre el saldo principal del préstamo hipotecario vigente en cada período de cálculo",
      "Sobre el valor catastral registrado en el Registro Público al momento de la escrituración",
      "Sobre el monto del abono inicial pagado por el comprador al momento del cierre",
    ],
    c: 1,
    exp: "El descuento del tramo preferencial se aplica directamente sobre el saldo principal del préstamo hipotecario vigente. Esto significa que a medida que el deudor va amortizando el préstamo y reduciendo el saldo, la base de cálculo del subsidio también se reduce proporcionalmente. El banco aplica la tasa preferencial sobre el saldo pendiente en cada período de cálculo de intereses.",
  },
  {
    q: "¿Está permitido el uso residencial dentro de la Zona Libre de Colón?",
    o: [
      "Sí, los propietarios de empresas pueden establecer su residencia dentro del perímetro si cuentan con autorización de la Junta Directiva",
      "No, la ZLC es un área exclusivamente comercial, industrial y de servicios donde no se permite la residencia permanente de ninguna persona",
      "Solo los corredores de bienes raíces con contratos activos en la zona pueden usar temporalmente espacios como residencia",
      "Solo los Gerentes Generales y directivos de empresas registradas pueden residir dentro de la zona con permiso especial",
    ],
    c: 1,
    exp: "La Zona Libre de Colón es un área estrictamente económica destinada al comercio internacional, logística e industria. El uso residencial no está permitido dentro de su perímetro; nadie tiene su residencia principal allí. Esta exclusividad de uso económico es lo que mantiene la coherencia del régimen especial y diferencia a la ZLC de áreas como Panamá-Pacífico que sí integran uso residencial.",
  },
];

const DemoModal = ({ isOpen, onClose, onRegister }) => {
  const [currentIdx, setCurrentIdx] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isAnswered, setIsAnswered] = useState(false);
  const [isFinished, setIsFinished] = useState(false);

  if (!isOpen) return null;

  const handleAnswer = (idx) => {
    if (isAnswered) return;
    setSelectedAnswer(idx);
    setIsAnswered(true);
  };

  const handleNext = () => {
    if (currentIdx === 9 || currentIdx === DEMO_QUESTIONS.length - 1) {
      setIsFinished(true);
    } else {
      setCurrentIdx((prev) => prev + 1);
      setSelectedAnswer(null);
      setIsAnswered(false);
    }
  };

  const question = DEMO_QUESTIONS[currentIdx];

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* MODAL: Se agregó max-h-[90vh] y overflow-y-auto para el scroll en móvil */}
      <div className="relative bg-white w-full max-w-3xl max-h-[90vh] md:max-h-none rounded-[2rem] md:rounded-[3rem] shadow-2xl overflow-y-auto animate-in fade-in zoom-in duration-300">
        {!isFinished && (
          <div className="px-6 pt-8 md:px-10 md:pt-10 flex items-center justify-between">
            <span className="px-4 py-1 bg-blue-100 text-blue-700 text-[10px] md:text-xs font-black rounded-full uppercase">
              Demo en vivo
            </span>
            <div className="flex items-center gap-3">
              <span className="text-xs md:text-sm font-bold text-slate-400">
                Pregunta {currentIdx + 1}/100
              </span>
              <div className="h-2 w-16 md:w-24 bg-slate-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-blue-600 transition-all"
                  style={{ width: `${(currentIdx + 1) * 10}%` }}
                />
              </div>
            </div>
          </div>
        )}

        <div className="p-6 md:p-10">
          {!isFinished ? (
            <div className="animate-fade">
              <h3 className="text-xl md:text-3xl font-black text-slate-800 leading-tight mb-6 md:mb-10">
                {question.q}
              </h3>

              <div className="grid gap-3 md:gap-4">
                {question.o.map((option, idx) => {
                  const isCorrect = idx === question.c;
                  const isSelected = idx === selectedAnswer;
                  const letter = String.fromCharCode(65 + idx);

                  let buttonClass =
                    "border-slate-100 hover:border-blue-300 hover:bg-blue-50/50";
                  let iconClass =
                    "bg-slate-100 text-slate-600 border-2 border-slate-200";

                  if (isAnswered) {
                    if (isCorrect) {
                      buttonClass =
                        "border-emerald-500 bg-gradient-to-r from-emerald-50 to-green-50";
                      iconClass =
                        "bg-emerald-500 text-white border-2 border-emerald-600";
                    } else if (isSelected && !isCorrect) {
                      buttonClass =
                        "border-rose-500 bg-gradient-to-r from-rose-50 to-red-50";
                      iconClass =
                        "bg-rose-500 text-white border-2 border-rose-600";
                    } else {
                      buttonClass =
                        "border-slate-100 bg-slate-50/50 opacity-60";
                    }
                  }

                  return (
                    <button
                      key={idx}
                      onClick={() => handleAnswer(idx)}
                      disabled={isAnswered}
                      className={`w-full text-left p-4 md:p-6 rounded-xl md:rounded-2xl border-2 font-bold text-slate-700 transition-all flex items-center gap-3 md:gap-4 ${buttonClass}`}
                    >
                      <span
                        className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg md:rounded-xl text-xs md:text-sm font-bold shrink-0 ${iconClass}`}
                      >
                        {letter}
                      </span>
                      <span className="flex-grow text-sm md:text-base">
                        {option}
                      </span>
                    </button>
                  );
                })}
              </div>

              {isAnswered && (
                <div className="mt-6 md:mt-8 animate-in slide-in-from-top-4 duration-500">
                  <div className="p-4 md:p-6 rounded-xl md:rounded-2xl bg-slate-50 border border-slate-200 mb-6">
                    <p className="font-black text-slate-800 mb-1 text-sm md:text-base">
                      Explicación:
                    </p>
                    <p className="text-slate-600 text-xs md:text-sm">
                      {question.exp}
                    </p>
                  </div>
                  <button
                    onClick={handleNext}
                    className="w-full py-4 bg-slate-900 text-white font-bold rounded-xl md:rounded-2xl hover:bg-slate-800 transition-all flex items-center justify-center gap-2 mb-2"
                  >
                    {currentIdx === 9 ? "Ver resultados" : "Siguiente pregunta"}
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-6 animate-fade pb-10">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-blue-100 rounded-3xl flex items-center justify-center mx-auto mb-6 md:mb-8 animate-bounce">
                <span className="text-3xl md:text-4xl">🚀</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-black text-slate-900 mb-4">
                ¡Buen trabajo!
              </h3>
              <p className="text-base md:text-lg text-slate-600 mb-8 md:mb-10">
                Has completado la demo gratuita. <br />
                <span className="font-bold text-blue-600 italic">
                  Si deseas continuar inscríbete hoy mismo gratis
                </span>
              </p>

              <div className="flex flex-col gap-4">
                <button
                  onClick={onRegister}
                  className="w-full py-4 md:py-5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-lg md:text-xl font-black rounded-xl md:rounded-2xl shadow-xl hover:scale-[1.02] transition-all"
                >
                  Registrarme Gratis Ahora
                </button>
                <button
                  onClick={onClose}
                  className="text-slate-400 font-bold hover:text-slate-600 underline decoration-slate-200"
                >
                  Cerrar y volver
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DemoModal;
